import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIResultsMessage from 'UIComponents/results/UIResultsMessage';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorNoResultsMessage = props => {
  const {
    message
  } = props;
  return /*#__PURE__*/_jsx(View, {
    margin: "auto",
    as: "div",
    children: /*#__PURE__*/_jsx(UIResultsMessage, {
      className: "m-all-0",
      illustration: "empty-state-charts",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: message
      })
    })
  });
};
export default EditorNoResultsMessage;